import { Box, Drawer, ModalClose, useTheme } from "@mui/joy";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NavigationPanel from "../NavigationPanel";
import BottomNav from "../BottomNav";

interface AppNavigationProps {
    collapsed: boolean;
    setCollapsed: (collapsed: boolean) => void;
    isMenuOpen: boolean;
    setIsMenuOpen: (open: boolean) => void;
}

export default function AppNavigation({
    collapsed,
    setCollapsed,
    isMenuOpen,
    setIsMenuOpen,
}: AppNavigationProps) {
    const theme = useTheme();
    const location = useLocation();

    // Responsive detection
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 600 && window.innerWidth < 1024);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsTablet(width >= 600 && width < 1024);
            setIsMobile(width < 600);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Auto-collapse/close on navigation
    useEffect(() => {
        if (isTablet && !collapsed) {
            setCollapsed(true);
        }
        if (isMobile) {
            setIsMenuOpen(false);
        }
    }, [location.pathname, isTablet, isMobile]);

    return (
        <>
            {/* Desktop/Tablet Sidebar */}
            {!isMobile && (
                <Box
                    sx={{
                        flexShrink: 0,
                        width: isTablet ? "5rem" : collapsed ? "5rem" : "18rem",
                        height: "100%",
                        position: "relative",
                        transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        zIndex: 10,
                    }}
                >
                    <Box
                        sx={{
                            width: collapsed ? "5rem" : "18rem",
                            transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease",
                            position: isTablet && !collapsed ? "absolute" : "relative",
                            zIndex: isTablet && !collapsed ? 1000 : 1,
                            height: "100%",
                            backgroundColor: "background.body",
                            borderRight: "1px solid",
                            borderColor: "divider",
                            top: 0,
                            left: 0,
                        }}
                    >
                        <NavigationPanel collapsed={collapsed} />
                    </Box>
                </Box>
            )}

            {/* Mobile Drawer */}
            <Drawer
                open={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
                sx={{
                    [`& .MuiDrawer-content`]: {
                        width: "18rem",
                        p: 0,
                    },
                }}
            >
                <ModalClose />
                <NavigationPanel collapsed={false} />
            </Drawer>

            {/* Mobile Bottom Nav */}
            {isMobile && <BottomNav onOpenMenu={() => setIsMenuOpen(true)} />}
        </>
    );
}
